import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState, useCallback } from "react";
import { GET } from "../service/CRUDService";
import { isPostIssuanceVerificationEnabledFromPermissions } from "../service/userPermissions";
import EntityConstants from "../configs/EntityConstants";
import Toast from "../common/Toast/Toast";
import { writePostLogoutNotice } from "../utils/postLogoutNotice";

const parseStoredOffset = (key) => {
  const raw = localStorage.getItem(key);
  if (raw === null) {
    return null;
  }
  const num = Number(raw);
  return Number.isNaN(num) ? null : num;
};

const AuthContext = React.createContext({
  signOrSignUp: true,
  chooseSignUp_SignIn: () => {},

  triggerLoginModuleToggleValue: false,
  setTriggerLoginModuleToggleValue: () => {},

  isLoggedIn: false,
  login: () => {},

  logout: () => {},

  createUserProfile: () => {},
  user_profile_id: null,

  createUserProfileDetails: () => {},
  userDetails: null,

  createTenantId: () => {},
  tenant_id: null,

  createTenantName: () => {},
  tenant_name: null,
  isSignUpHandler: () => {},
  isSignUp: null,

  isGoogleLogin: false,
  googlelogin: () => {},

  googlelogout: () => {},

  isMicrosoftLogin: false,
  microsoftlogin: () => {},
  microsoftlogout: () => {},

  hasDiscoveryReachedBottomHandler: () => {},
  hasDiscoveryReachedBottom: false,

  lastVisitedPathHandler: () => {},
  lastVisitedPath: null,

  IssuedOffsetHandler: () => {},
  issuedOffset: null,

  ProgrammeOffsetHandler: () => {},
  programmeOffset: null,

  BatchOffsetHandler: () => {},
  batchOffset: null,

  DraftOffsetHandler: () => {},
  draftOffset: null,

  TenantOffsetHandler: () => {},
  tenantOffset: null,

  forgotPasswordHandler: () => {},
  isForgotPassword: false,

  rowCount: 0,
  setRowCount: () => {},

  isFileUploaded: false,
  setFileUploaded: () => {},

  creditCount: 0,
  setCreditCount: () => {},

  sidebarComponents: [],
  setSidebarComponents: () => {},

  isTransferEnabled: false,
  setIsTransferEnabled: () => {},

  isPostIssuanceVerificationEnabled: false,
  setIsPostIssuanceVerificationEnabled: () => {},

  isWhiteLabelEnabled: false,
  setIsWhiteLabelEnabled: () => {},

  isHtmlDesignsEnabled: false,
  setIsHtmlDesignsEnabled: () => {},

  isNewUserOnboarding: false,
  setIsNewUserOnboarding: () => {},

  syncUserPermissions: async () => {},
  bootstrapUserSession: async () => null,
  refreshUserSession: async () => null,

  userType: null,
  setUserType: () => {},

  tenantCode: null,
  setTenantCode: () => {},

  orgCode: null,
  setOrgCode: () => {},

  selectedLanguage: "en",
  setSelectedLanguage: () => {},

  isLoading: true,

  profilePhotoCache: 0,
});

export const AuthContextProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user_profile_id, setUser_profile_id] = useState(null);
  const [tenant_id, setTenant_id] = useState(null);
  const [tenant_name, setTenant_Name] = useState(null);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isGoogleLogin, setIsGoogleLogin] = useState(false);
  const [isMicrosoftLogin, setIsMicrosoftLogin] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [hasDiscoveryReachedBottom, setHasDiscoveryReachedBottom] =
    useState(false);
  const [lastVisitedPath, setLastVisitedPath] = useState(null);
  const [issuedOffset, setIssuedOffset] = useState(
    parseStoredOffset("transactionOffset"),
  );
  const [programmeOffset, setProgrammeOffset] = useState(
    parseStoredOffset("programmeOffset"),
  );
  const [batchOffset, setBatchOffset] = useState(
    parseStoredOffset("batchOffset"),
  );
  const [draftOffset, setDraftOffset] = useState(
    parseStoredOffset("draftOffset"),
  );

  const [tenantOffset, setTenantOffset] = useState(
    parseStoredOffset("tenantOffset"),
  );
  const [triggerLoginModuleToggleValue, setTriggerLoginModuleToggleValue] =
    useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [creditCount, setCreditCount] = useState(0);
  const [sidebarComponents, setSidebarComponents] = useState([]);
  const [isTransferEnabled, setIsTransferEnabled] = useState(false);
  const [
    isPostIssuanceVerificationEnabled,
    setIsPostIssuanceVerificationEnabled,
  ] = useState(false);
  const [isWhiteLabelEnabled, setIsWhiteLabelEnabled] = useState(false);
  const [isHtmlDesignsEnabled, setIsHtmlDesignsEnabled] = useState(false);
  const [isNewUserOnboarding, setIsNewUserOnboarding] = useState(false);
  const [userType, setUserType] = useState(null);
  const [signOrSignUp, setSignOrSignUp] = useState(true);
  const [tenantCode, setTenantCode] = useState(null);
  const [orgCode, setOrgCode] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "en",
  );
  const [profilePhotoCache, setprofilePhotoCache] = useState(0);

  useEffect(() => {
    const logoutReason = localStorage.getItem("logout_reason");
    if (logoutReason === "session_timeout") {
      Toast({
        type: "warning",
        title: "Session Timeout",
        message:
          "You have been logged out due to session timeout. Please sign in again.",
      });
      localStorage.removeItem("logout_reason");
    }
  }, []);

  // useEffects:
  useEffect(() => {
    lastVisitedPath && sessionStorage.setItem("previousPath", lastVisitedPath);
  }, [lastVisitedPath]);

  useEffect(() => {
    console.log("isForgotPasswordOpen>>>>", isForgotPasswordOpen);
  }, [isForgotPasswordOpen]);

  useEffect(() => {
    console.log(
      "triggerLoginModuleToggleValue>>",
      triggerLoginModuleToggleValue,
    );
  }, [triggerLoginModuleToggleValue]);

  const resetUserDetails = useCallback(() => {
    setIsLoggedIn(false);
    setUser_profile_id(null);
    setTenant_id(null);
    setTenant_Name(null);
    setIsGoogleLogin(false);
    setIsMicrosoftLogin(false);
    setUserDetails({});
    setSidebarComponents([]);
    setIsTransferEnabled(false);
    setIsPostIssuanceVerificationEnabled(false);
    setIsWhiteLabelEnabled(false);
    setIsNewUserOnboarding(false);
    setUserType(null);
    setprofilePhotoCache(0);
    setProgrammeOffset(0);
    setBatchOffset(0);
    setDraftOffset(0);
    setTenantOffset(0);
    setTenantCode(null);
    setOrgCode(null);
  }, []);

  const clearStoredSession = useCallback(() => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("userType");
  }, []);

  const syncUserPermissions = useCallback(async () => {
    try {
      const response = await GET(EntityConstants.CURRENT_USER_PERMISSIONS);
      if (!response.ok) {
        throw new Error("Failed to fetch user permissions");
      }

      const data = await response.json();
      setSidebarComponents(data.sidebar_components || []);
      setIsTransferEnabled(data.is_transfer_enabled === true);
      setIsPostIssuanceVerificationEnabled(
        isPostIssuanceVerificationEnabledFromPermissions(data),
      );
      setIsWhiteLabelEnabled(data.is_white_label_enabled === true);
      setIsHtmlDesignsEnabled(data.is_html_designs_enabled === true);
      setIsNewUserOnboarding(data.is_new_user_onboarding === true);
      return data;
    } catch (error) {
      setSidebarComponents([]);
      setIsTransferEnabled(false);
      setIsPostIssuanceVerificationEnabled(false);
      setIsWhiteLabelEnabled(false);
      setIsHtmlDesignsEnabled(false);
      setIsNewUserOnboarding(false);
      console.error("Error fetching user permissions:", error);
      return null;
    }
  }, []);

  const forceLogout = useCallback(
    (reason = "manual", { emitAuthEvent = true, details = null } = {}) => {
      resetUserDetails();

      localStorage.clear();
      sessionStorage.clear();

      if (reason === "session_expired") {
        localStorage.setItem("logout_reason", "session_timeout");
      }

      // Written after the wipes above so it survives into the reload that
      // follows, where it is shown once and removed.
      if (reason === "password_updated") {
        writePostLogoutNotice({
          type: "password_updated",
          email: details?.email || "",
        });
      }

      if (emitAuthEvent) {
        localStorage.setItem(
          "auth_event",
          JSON.stringify({ type: "LOGOUT", reason: reason, t: Date.now() }),
        );
      }
      window.location.replace("/");
    },
    [resetUserDetails],
  );

  const applyUserSessionDetails = useCallback((userData) => {
    if (!userData) {
      return;
    }

    const normalizedUserType =
      userData.user_type?.toLowerCase() || userData.type?.toLowerCase() || null;

    setUserType(normalizedUserType);
    setUserDetails(userData);
    setprofilePhotoCache(Date.now());
    if (userData.tenant_code) {
      setTenantCode(userData.tenant_code);
    }
    if (userData.org_code) {
      setOrgCode(userData.org_code);
    }
    localStorage.setItem("userType", normalizedUserType);
  }, []);

  const bootstrapUserSession = useCallback(
    async (userData, options = {}) => {
      const { logoutReason = null } = options;

      setIsLoggedIn(true);
      applyUserSessionDetails(userData);

      const permissions = await syncUserPermissions();
      if (permissions) {
        return permissions;
      }

      if (logoutReason) {
        forceLogout(logoutReason);
        return null;
      }

      resetUserDetails();
      clearStoredSession();
      return null;
    },
    [
      applyUserSessionDetails,
      clearStoredSession,
      forceLogout,
      resetUserDetails,
      syncUserPermissions,
    ],
  );

  const refreshUserSession = useCallback(
    async (userData) => {
      setIsLoggedIn(true);
      applyUserSessionDetails(userData);
      return syncUserPermissions();
    },
    [applyUserSessionDetails, syncUserPermissions],
  );

  const isRefreshTokenExpired = () => {
    try {
      const token = localStorage.getItem("refresh_token");
      if (!token) return true;
      const { exp } = jwtDecode(token);
      return Date.now() >= exp * 1000;
    } catch {
      return true;
    }
  };

  const validateSession = useCallback(async () => {
    const access = localStorage.getItem("auth_token");
    const refresh = localStorage.getItem("refresh_token");

    if (!access && !refresh) {
      setIsLoading(false);
      return false;
    }

    if (isRefreshTokenExpired()) {
      forceLogout("session_expired");
      return false;
    }

    try {
      const token = localStorage.getItem("auth_token");
      if (!token) throw new Error("No access token");
      const response = await GET(`${EntityConstants.CURRENT_USER}`);

      if (response.ok) {
        const data = await response.json();
        const permissions = await bootstrapUserSession(data, {
          logoutReason: "session_expired",
        });
        return permissions !== null;
      } else {
        throw new Error("Access token invalid");
      }
    } catch {
      forceLogout("session_expired");
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [bootstrapUserSession, forceLogout]);

  useEffect(() => {
    validateSession();
  }, [validateSession]);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "auth_event") {
        try {
          const evt = JSON.parse(e.newValue || "{}");
          if (evt.type === "LOGOUT") {
            const logoutReason = evt.reason || "manual";
            forceLogout(logoutReason, { emitAuthEvent: false });
          }
        } catch {
          // ignore JSON parse errors
        }
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const createUserProfile = (id) => {
    setUser_profile_id(id);
  };

  const createUserProfileDetails = (userDetails) => {
    if (typeof userDetails === "object") {
      const normalizedUserType =
        userDetails.user_type?.toLowerCase() ||
        userDetails.type?.toLowerCase() ||
        null;

      setUserDetails(userDetails);
      setUserType(normalizedUserType);
      setprofilePhotoCache(Date.now());
      if (userDetails.tenant_code) {
        setTenantCode(userDetails.tenant_code);
      }
      if (userDetails.org_code) {
        setOrgCode(userDetails.org_code);
      }
    } else {
      setUserDetails({});
      setUserType(null);
      setSidebarComponents([]);
      setIsTransferEnabled(false);
      setIsPostIssuanceVerificationEnabled(false);
      setIsWhiteLabelEnabled(false);
      throw new Error(
        '"object" / "{}" expected to create user profile details',
      );
    }
  };

  const createTenantId = (tenant_id) => {
    setTenant_id(tenant_id);
  };

  const createTenantName = (tenant_name) => {
    setTenant_Name(tenant_name);
  };

  const isSignUpHandler = (bool) => {
    setIsSignUp(bool);
  };

  const loginHandler = (userData) => {
    setIsLoggedIn(true);
    applyUserSessionDetails(userData);
  };

  const logoutHandler = (reason, details) => {
    const logoutReason = typeof reason === "string" ? reason : "manual";
    forceLogout(logoutReason, { details });
  };

  const googleloginHandler = () => {
    setIsGoogleLogin(true);
  };

  const googlelogoutHandler = () => {
    setIsGoogleLogin(false);
  };

  const microsoftLoginHandler = () => {
    setIsMicrosoftLogin(true);
  };

  const microsoftLogoutHandler = () => {
    setIsMicrosoftLogin(false);
  };

  const hasDiscoveryReachedBottomHandler = (bool) => {
    setHasDiscoveryReachedBottom(bool);
  };

  const lastVisitedPathHandler = (lastVisitedPath_) => {
    setLastVisitedPath(lastVisitedPath_);
  };

  const IssuedOffsetHandler = (offset) => {
    setIssuedOffset(offset);
    localStorage.setItem("transactionOffset", offset);
  };

  const ProgrammeOffsetHandler = (offset) => {
    setProgrammeOffset(offset);
    localStorage.setItem("programmeOffset", offset);
  };

  const BatchOffsetHandler = (offset) => {
    setBatchOffset(offset);
    localStorage.setItem("batchOffset", offset);
  };

  const TenantOffsetHandler = (offset) => {
    setTenantOffset(offset);
    localStorage.setItem("tenantOffset", offset);
  };

  const chooseSignUp_SignInHandler = (isSignIn) => {
    setSignOrSignUp(isSignIn);
  };

  const DraftOffsetHandler = (offset) => {
    setDraftOffset(offset);
    localStorage.setItem("draftOffset", offset);
  };

  const contextValue = {
    signOrSignUp: signOrSignUp,
    chooseSignUp_SignIn: chooseSignUp_SignInHandler,

    triggerLoginModuleToggleValue: triggerLoginModuleToggleValue,
    setTriggerLoginModuleToggleValue: setTriggerLoginModuleToggleValue,

    isLoggedIn,
    isLoading,
    login: loginHandler,

    logout: logoutHandler,

    createUserProfile: createUserProfile,
    user_profile_id: user_profile_id,

    createUserProfileDetails: createUserProfileDetails,
    userDetails: userDetails,

    createTenantId: createTenantId,
    tenant_id: tenant_id,

    createTenantName: createTenantName,
    tenant_name: tenant_name,

    isSignUpHandler: isSignUpHandler,
    isSignUp: isSignUp,

    isGoogleLogin,
    googlelogin: googleloginHandler,

    googlelogout: googlelogoutHandler,

    hasDiscoveryReachedBottomHandler: hasDiscoveryReachedBottomHandler,
    hasDiscoveryReachedBottom: hasDiscoveryReachedBottom,

    lastVisitedPathHandler: lastVisitedPathHandler,
    lastVisitedPath: lastVisitedPath,

    IssuedOffsetHandler: IssuedOffsetHandler,
    issuedOffset: issuedOffset,

    ProgrammeOffsetHandler: ProgrammeOffsetHandler,
    programmeOffset: programmeOffset,

    BatchOffsetHandler: BatchOffsetHandler,
    batchOffset: batchOffset,

    DraftOffsetHandler: DraftOffsetHandler,
    draftOffset: draftOffset,

    TenantOffsetHandler: TenantOffsetHandler,
    tenantOffset: tenantOffset,

    isMicrosoftLogin,
    microsoftLogin: microsoftLoginHandler,
    microsoftLogout: microsoftLogoutHandler,

    isForgotPassword: isForgotPasswordOpen,
    forgotPasswordHandler: () => setIsForgotPasswordOpen(!isForgotPasswordOpen),

    rowCount,
    setRowCount,

    isFileUploaded: fileUploaded,
    setFileUploaded,

    creditCount,
    setCreditCount,

    userType,
    setUserType,

    sidebarComponents,
    setSidebarComponents,

    isTransferEnabled,
    setIsTransferEnabled,

    isPostIssuanceVerificationEnabled,
    setIsPostIssuanceVerificationEnabled,

    isWhiteLabelEnabled,
    setIsWhiteLabelEnabled,

    isHtmlDesignsEnabled,
    setIsHtmlDesignsEnabled,

    isNewUserOnboarding,
    setIsNewUserOnboarding,

    syncUserPermissions,
    bootstrapUserSession,
    refreshUserSession,

    tenantCode,
    setTenantCode,

    orgCode,
    setOrgCode,

    selectedLanguage,
    setSelectedLanguage: (lang) => {
      setSelectedLanguage(lang);
      localStorage.setItem("selectedLanguage", lang);
    },

    profilePhotoCache,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
